module.exports = __webpack_public_path__ + "static/media/fourth-banner.81858ca9.png";